var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93588 20.9294H9.06413V20.0319H4.93588V20.9294ZM1.88475 23.6667C1.34769 23.6667 0.899306 23.4868 0.539583 23.1271C0.179861 22.7674 0 22.319 0 21.7819V2.21808C0 1.68102 0.179861 1.23263 0.539583 0.872912C0.899306 0.513189 1.34769 0.333328 1.88475 0.333328H12.1153C12.6523 0.333328 13.1007 0.513189 13.4604 0.872912C13.8201 1.23263 14 1.68102 14 2.21808V21.7819C14 22.319 13.8201 22.7674 13.4604 23.1271C13.1007 23.4868 12.6523 23.6667 12.1153 23.6667H1.88475ZM1.16667 18.4616V21.7819C1.16667 21.9616 1.24143 22.1262 1.39096 22.2757C1.54049 22.4252 1.70508 22.5 1.88475 22.5H12.1153C12.2949 22.5 12.4595 22.4252 12.609 22.2757C12.7586 22.1262 12.8333 21.9616 12.8333 21.7819V18.4616H1.16667ZM1.16667 17.2949H12.8333V4.41666H1.16667V17.2949ZM1.16667 3.24999H12.8333V2.21808C12.8333 2.03841 12.7586 1.87381 12.609 1.72429C12.4595 1.57476 12.2949 1.49999 12.1153 1.49999H1.88475C1.70508 1.49999 1.54049 1.57476 1.39096 1.72429C1.24143 1.87381 1.16667 2.03841 1.16667 2.21808V3.24999Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileicon);
export default __webpack_public_path__ + "static/media/mobile icon.09c770b71f24f7b6eb8a0e2a23169b8d.svg";
export { ForwardRef as ReactComponent };